module.exports = __webpack_public_path__ + "static/media/Diverse.81c7e0ce.png";